import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import update from "@beeldit/core/services/update";
import {useContext} from "react";
import {ActiveOrDisableActionContext} from "@main/customers/actions/active-or-disable-account/ActiveOrDisableActionContext";

function useActiveOrDisableAccount() {
    const { user } = useContext(ActiveOrDisableActionContext);
    const errorHandler = useErrorHandler();

    return (onSuccess: any) => {
        update("users/change-status", user.id, user)
            .then((response: any) => {
                onSuccess();
            })
            .catch((error: any) => {
                errorHandler(error);
            });
    };
}

export default useActiveOrDisableAccount;
